<template>
<div class="container-fluid">
    <div class="content-header pb-0">
        <div class="content-header pt-1 pb-0">
			<h5><b>Request for Admission with Regard to Transfer of Parents etc.</b></h5>
		</div>
    </div>
    <div class="card">
		<div class="card-body">
			<form id="" class="form-horizontal" enctype="multipart/form-data" action="#" method="POST">
				<div class="form-group" id="main_form">
					<small><i>(*Note: Once DEO/TEO accepted your admission request, your admission will open on behalf of requested dzongkhag))</i></small><br>
					<h5><u><b>Student Details</b></u></h5><br>
					<div class="row form-group">
						<div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
							<label class="required" >CID No/Reference  : </label>
							<label class="text-primary">{{std_admission_details.CidNo}}</label>
						</div>
						<template v-if="!is_student">
							<div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
								<label class="required" >Name of Student :</label>
								<label class="text-primary">{{ std_admission_details.FirstName}} {{ std_admission_details.MiddleName=='null' ? '': std_admission_details.MiddleName}} {{ std_admission_details.LastName=='null' ? '': std_admission_details.LastName}}</label>
							</div>
						</template>
						<template v-else>
							<div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
								<label class="required" >Name of Student :</label>
								<label class="text-primary">{{ std_admission_details.Name}} </label>
							</div>
						</template>
					</div>
					<div class="row form-group">
						<div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
							<label class="required" >Gender :</label>
							<label class="text-primary">{{ genderArray[std_admission_details.CmnSexId]}}</label>
						</div>
						<div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
							<label >Date of Birth :</label>
							<label class="text-primary">{{std_admission_details.DateOfBirth}}</label>
						</div>
					</div>
					<!-- <div class="row form-group">
						<div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
							<label class="required" >Dzongkhag : </label>
							<label class="text-primary">{{this.student_form.dzongkhag}}</label>
						</div> -->
						<!-- <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
							<label class="required" >Gewog : </label>
							<label class="text-primary"><span id="gewogid"></span>{{this.student_form.gewog}}</label>
						</div>
						<div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
							<label class="required" >Chewog :</label>
							<label class="text-primary"><span id="vilageId"></span> {{this.student_form.chewog}}</label>
						</div> -->
					<!-- </div> -->
				</div>
				<hr><br>
				<template v-if="!admission_requested">
					<div class="row md-12">
						<div class="form-group col-md-3">
							<label class="required">Dzongkhag/Thromde <span class="text-danger">*</span><span class="text-danger"></span></label>
							<select name="dzongkhag" v-model="student_form.dzongkhag" :class="{ 'is-invalid select2 select2-hidden-accessible': student_form.errors.has('dzongkhag') }" class="form-control select2" id="dzongkhag"  >
								<option value="">--- Please Select ---</option>
								<option v-for="(item, index) in dzongkhagList" :key="index" v-bind:value="item.id">{{item.name}}</option>
							</select>
						</div>

						<div class="form-group col-md-3">
							<label>Class<span class="text-danger">*</span></label>
							<input type="text" class="form-control" @change="removeerror('class')" :class="{ 'is-invalid': student_form.errors.has('class') }" id="class" v-model="student_form.class" disabled="true">
								<has-error :form="student_form" field="class"></has-error>
						</div>
						<div class="form-group col-md-3">
							<label>Request Date:<span class="text-danger">*</span></label>
								<input type="date" class="form-control" @change="removeerror('dateOfapply')" :class="{ 'is-invalid': student_form.errors.has('dateOfapply') }" id="dateOfapply" v-model="student_form.dateOfapply" disabled="true">
								<has-error :form="student_form" field="date"></has-error>
						</div>
					</div>
					<div class="row md-12">
						<div class="form-group col-md-12" >
							<label>Reason <span class="text-danger">*</span><span class="text-danger"></span></label>
								<textarea v-model="student_form.reasons" id="reasons" type="text" name="reasons" class="form-control" :class="{ 'is-invalid': student_form.errors.has('reasons') }"   />
							<has-error :form="student_form" field="reasons"></has-error>
						</div>
					</div>
					<!-- <small><i>(Please upload any supporting documents (e.g. Transfer Order etc.))</i></small><br> -->
					<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
						<div class="form-group col-md-12">
							<small><i>(*Note: All the related documents need to be compiled into one document and upload)</i></small><br>
							<label>Supporting Document:<span class="text-danger">*</span>(Max File Size 1.5 MB)</label><br>
							<small><i>(Any document that will strengthen your application to the new school e.g concern letter)</i></small>
							<input type="file" name="attachments" class="form-control" v-on:change="onChangeFileUpload" id="attachment">
							<has-error :form="student_form" field="attachments"></has-error>
						</div>
					</div>
					<div class="footer float-right" >
						<button type="button" v-on:click="resetForm" class="btn btn-danger"><i class="fas fa-redo"></i> Reset</button>
						<button type="button" v-on:click="submitForm" class="btn btn-success"> <i class="fas fa-save"></i> Request</button>
					</div>
				</template>
				<template v-else>
					<div class="form-group" id="main_form">
						<h5><u><b>Admission Request Details</b></u></h5><br>
						<div class="row form-group">
							<div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
								<label class="required" >Dzongkhag For Admission Request: </label>
								<label class="text-primary">{{dzongkhagArray[this.new_dzongkhag_admission]}}</label>
							</div>
							<div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
								<label class="required" >Date of Application:</label>
								<label class="text-primary">{{ this.admission_request_date}}</label>
							</div>
						</div>
						<div class="row form-group">
							<div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
								<label class="required" >Reasons :</label>
								<label class="text-primary">{{ this.admission_request_reason}}</label>
							</div>
							<div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
								<label class="required" >Application Status :</label>
								<label class="text-primary">{{ this.status}}</label>
							</div>
							<div class="col-lg-4 col-md-4 col-sm-4 col-xs-12" v-if="this.attachments">
								<label class="required" >Uploaded Document :</label>
								<a href="#" @click="openfile(this.attachments)" class="fa fa-download"> Download</a>
							</div>
						</div>
					</div>
				</template>
				<div>
				</div>
				<div class="form-group" id="approvedId"  >
						<h5><u><b>Approved Details</b></u></h5><br>
						<div class="row form-group" >
							<div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
								<label class="required" >Dzongkhag/Thromde: </label>
								<label class="text-primary">{{ this.student_form.ApprovedDzongkhag }}</label>
							</div>
							<div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
								<label class="required" >Gewog:</label>
								<label class="text-primary">{{ this.student_form.ApprovedGewog }}</label>
							</div>
							<div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
								<label class="required" >School Name :</label>
								<label class="text-primary">{{ this.student_form.ApprovedSchool}} {{this.student_form.ApprovedLevel}}</label>
							</div>
						</div>
				</div>
			</form>
		</div>
    </div>
</div>
</template>
<script>

export default {
	data(){
		return{
			is_student:false,
			admission_requested:false,
            std_id:'',
            std_class:'',
            org_id:'',
            parent_school_dzongkhag:'',
			std_admission_details:'',
			OrgDetails:'',
			getDzoName:'',
			getGewogName:'',
			dzongkhagList:[],
			schoolList:[],
			classList:[],
			streamList:[],
			getreasons:'',
			genderArray:{},
			dzongkhagArray:{},
            gewogArray:{},
			attachments:[],
            villageArray:{},
			dzongkhagId:'null',
			gewogId:'null',
			new_dzongkhag_admission:'',
			admission_request_date:'',
			admission_request_reason:'',
			admission_request_files:'',
			student_form: new form({
				id:'',
				student_id:'',
				dzongkhag:'',
				gewog:'',
				village:'',
				school:'',
				class:'',
				stream:'',
				status:'pending',
				ApprovedDzongkhag:'',
				ApprovedGewog:'',
				ApprovedSchool:'',
				ApprovedLevel:'',
				dateOfapply:new Date().toISOString().substr(0, 10),
				reasons:'',
				attachments:''
                [{
                    file_name:'', attachment:''
                }],
				ref_docs:[],
			})
		}
	},
	methods:{
		onChangeFileUpload(e){
            this.student_form.attachments = e.target.files[0];
        },
		openfile(file){
			alert(file);
            let file_path=file.replaceAll('/', 'SSS');
            let uri = 'admissions/viewFiles/'+file_path;
            window.open(uri,"_black");
        },
        addMore: function(){
            this.student_form.attachments.push({file_name:'', file_upload:''})
        },
        remove(index){
            if(this.student_form.attachments.length>1){
                this.student_form.attachments.pop();
            }
        },
		resetForm: function(event){
			this.student_form.reset();
		},

		showAndHideField:function(type){
			if(type=="classXI"){
				$('#stream').show();
			}

			if(type=="others"){
				$('#stream').hide();
			}
		},

		submitForm(){
			Swal.fire({
				text: "Are you sure you wish to request for admission?",
				icon: 'info',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes!',
				}).then((result) => {
				if (result.isConfirmed) {
					const config = {
						headers: {
							'content-type': 'multipart/form-data'
						}
				}
			this.$Progress.start();
			let formData = new FormData();
			formData.append('student_id', this.student_form.student_id);
			formData.append('dzongkhag', this.student_form.dzongkhag);//this.student_form.dzongkhag
			formData.append('org_id', this.org_id);
			formData.append('cid_no', this.CidNo);
			formData.append('name', this.name);
			formData.append('dob', this.dob);
			formData.append('student_code', this.student_code);
			formData.append('sexId', this.sexId);
			formData.append('class', this.student_form.class);
			formData.append('dateOfapply', this.student_form.dateOfapply);
			formData.append('reasons', this.student_form.reasons);
			formData.append('attachments', this.student_form.attachments);
			formData.append('status', 'submitted');

			axios.post('/admissions/saveAdmissionRequest',formData,config)
			.then((response)=>{
				if(response.data!=""){
					Swal.fire({
						html: "Your request has been submitted successfully ",
						icon: 'success',
						confirmButtonColor: '#3085d6',
						cancelButtonColor: '#d33',
						confirmButtonText: 'okay!',
				});
					this.$router.push({name:'acknowledgement_admission'});
				}
			})
			.catch((error) => {
				this.form.errors.errors = error.response.data;
				});
			}
			});
		},
		getdzongkhagList(uri ='masters/loadGlobalMasters/all_active_dzongkhag'){
			axios.get(uri)
			.then(Response =>{
			let data = Response.data.data;
			this.dzongkhagList = data;
			for(let i=0;i<data.length;i++){
                    this.dzongkhagArray[data[i].id] = data[i].name;
                }
                $('#dzongkhag').prop('disabled',false);
            }).catch(error => console.log(error));

		},
		getschoolList(id){
			let dzoId=$('#dzongkhag').val();
			if(id!=""){
				dzoId=id;
			}
			axios.get('/masters/getOrgList/' +dzoId)
				.then(response =>{
				let data = response.data.data;
				this.schoolList = data;
			})
		},
		loadGenderList(uri="masters/loadGlobalMasters/all_active_gender"){
            axios.get(uri)
            .then(response => {
                let data = response;
                this.sex_idList =  data.data.data;
                for(let i=0;i<data.data.data.length;i++){
                    this.genderArray[data.data.data[i].id] = data.data.data[i].name;
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        },

		getclassList(id){
			let orgId=$('#school').val();
				if(id!=""){
				orgId=id;
			}
			axios.get('/masters/loadClassStreamSection/NA/' +orgId)
			.then(Response =>{
				let data = Response.data;
				// console.log(data);
				this.classList = data;
			})
		},

		getstreamListByid(id){
			let classId=$('#class').val();
				if(id!=""){
				classId=id;
			}
			axios.get('/masters/getStreamByclassId/' +classId)
			.then(Response =>{
				let data = Response.data;
				// console.log(data);
				this.classList = data;
			})
		},

		getstreamList(uri ='masters/loadGlobalMasters/all_active_dzongkhag'){
			axios.get(uri)
			.then(Response =>{
				let data = Response.data.data;
				this.streamList = data;
			})
		},

		// getOrgDetails(id){
		// 	axios.get('organizations/loadOrganizationDetailsbyOrgId/' +id)
		// 	.then(response =>{
		// 		let data = response.data.data;
		// 		if(data!="" ||data!=null){
		// 			// this.student_form.dzongkhag=data.dzongkhag;
		// 			this.student_form.gewog=data.gewog;
		// 			this.student_form.chewog=data.chewog;
		// 		}	
		// 	})
		// },
		getdzongkhagName(dzo_id){
			axios.get('masters/load_dzongkhag_details_by_id/' +dzo_id)
			.then(response =>{
				let data = response.data.data;
				this.getDzoName=data;
			})

		},
		getgewogName(gewog_id){
			axios.get('masters/load_gewog_details_by_id/' +gewog_id)
			.then(response =>{
				let data = response.data.data;
				this.getGewogName=data;
			})
		},

		getstudentPersonalDetails(type){
            axios.get('/admissions/getStudentDetailsFromPortal/'+type)
                .then(response => {
                let data = response.data;
                if(data != ""){
                    this.std_admission_details=data;
                    this.org_id = data.OrgOrganizationId;
					this.CidNo = data.CidNo;
					this.name = data.Name,
					this.dob = data.DateOfBirth;
					this.student_code = data.student_code;
					this.sexId = data.CmnSexId;
                    this.getStudentClass(data.id);
					// this.getOrgDetails(data.OrgOrganizationId);
					// this.attachments=data.documents;
                    // this.student_form.student_id=data.id;
                    // this.getGewogList(data.CmnDzoId,data.CmnGewogId);
                    // this.getvillagelist(data.CmnGewogId,data.CmnChiwogId);
                }
                // else{
                //     $('#main_form').hide();
                //     $('#message').html('You are not yet registered in the system. Please register your self first to proceed further from here. <br> Thank you!');
                //     $('#screenPermission').show();
                // }
            });
        },

		loadAdmissionRequest(std_id){
			axios.get('/admissions/loadAdmissionRequest/'+std_id)
			.then(response => {
                let data = response.data.data;
                if(data != null && data!=''){
					this.admission_requested = true;
                    this.new_dzongkhag_admission=data.ClusterdzongkhagId;
                    this.admission_request_date = data.dateOfapply;
                    this.admission_request_reason=data.reasons;
                    this.status=data.status;
					// this.getApprovedOrgDetails(data.approvedOrgId)
					if(this.status=="Accepted in School"){
						$('#approvedId').show();
					}
					else{
						$('#approvedId').hide();

					}
                }
				this.attachments = data.attachement_path;
			});
		},
		// getApprovedOrgDetails(orgid){
		// 	axios.get('organizations/loadOrganizationDetailsbyOrgId/' +orgid)
		// 	.then(response =>{
		// 		let data = response.data.data;
		// 		if(data!="" ||data!=null){
		// 			// this.student_form.ApprovedDzongkhag=data.dzongkhag;
		// 			this.student_form.ApprovedGewog=data.gewog;
		// 			this.student_form.ApprovedSchool=data.name;
		// 			this.student_form.ApprovedLevel=data.level_name;
		// 		}	
		// 	})
		// },

		getStudentClass(std_id){
            let uri = '/students/getStudentClassId/'+ std_id;
            try{
                axios.get(uri).then(response => {
                    let data= response.data.data;
                    this.std_class=data.class;
                    this.student_form.class = this.std_class;
                });
            }catch(e){
                console.log('error loadactivedzongkhags '+e);
            }
        },

		applyselect(){
			if(!$('#dzongkhag').attr('class').includes('select2-hidden-accessible')){
				$('#dzongkhag').addClass('select2-hidden-accessible');
			}
			if(!$('#school').attr('class').includes('select2-hidden-accessible')){
				$('#school').addClass('select2-hidden-accessible');
			}
			if(!$('#class').attr('class').includes('select2-hidden-accessible')){
				$('#class').addClass('select2-hidden-accessible');
			}
			if(!$('#stream').attr('class').includes('select2-hidden-accessible')){
				$('#stream').addClass('select2-hidden-accessible');
			}
		},
		removeerror(fieldid){
			if($('#'+fieldid).val()!=""){
				$('#'+fieldid).removeClass('is-invalid');
				$('#'+errid).html('');
			}
		},

		async changefunction(id){
			if($('#'+id).val()!=""){
				$('#'+id).removeClass('is-invalid select2');
				$('#'+id+'_err').html('');
				$('#'+id).addClass('select2');
			}

			if(id=="dzongkhag"){
				this.student_form.dzongkhag=$('#dzongkhag').val();
			}
		}
	},

	async mounted() {
		$('#approvedId').hide();
		$('.select2').select2();
		$('.select2').select2({
			theme: 'bootstrap4'
		});
		$('.select2').on('select2:select', function (el){
			Fire.$emit('changefunction',$(this).attr('id'));
		});

		Fire.$on('changefunction',(id)=> {
			this.changefunction(id);
		});
        axios.get('getSessionDetail')
        .then(response => {
            let data = response.data.data;
            this.std_id=data['std_id'];
            let user_type=data['user_type'];
            if(data['user_type']!="Parent"){
                this.is_student=true;
            }
            this.getstudentPersonalDetails(user_type);
			this.student_form.student_id=data.std_id;
			this.loadAdmissionRequest(data['std_id']);
        })
        .catch(errors => {
            console.log(errors)
        });

        $('.select2').select2({
        theme: 'bootstrap4'
        });
        $('.select2').on('select2:select', function (el){
            Fire.$emit('changefunction',$(this).attr('id'));
        });
        Fire.$on('changefunction',(id)=> {
            this.changefunction(id);
        });
        this.getdzongkhagList();
		this.getclassList();
		this.getstreamList();
		this.getdzongkhagName();
		this.getgewogName();
        this.loadGenderList();
    },
}
</script>
